import { render, staticRenderFns } from "./CrewAspBulkSelected.vue?vue&type=template&id=16206aa0"
import script from "./CrewAspBulkSelected.vue?vue&type=script&lang=js"
export * from "./CrewAspBulkSelected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports